import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

/**
 * Section - A titled container for grouping SectionRow items.
 */
export const Section = ({ title, theme, children }) => {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      {title && (
        <div style={{
          fontSize: '0.75rem',
          fontWeight: '600',
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          color: theme?.text?.secondary || '#6b7280',
          marginBottom: '0.5rem',
          paddingLeft: '0.25rem',
        }}>
          {title}
        </div>
      )}
      <div style={{
        background: theme?.backgrounds?.card || '#fff',
        border: `1px solid ${theme?.borders?.primary || '#e5e7eb'}`,
        borderRadius: '0.75rem',
        overflow: 'hidden',
      }}>
        {children}
      </div>
    </div>
  );
};

/**
 * SectionRow - A clickable row with icon, title, optional subtitle, and chevron.
 */
export const SectionRow = ({ icon, iconColor, title, subtitle, onClick, theme, isLast, textColor }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0.875rem 1rem',
        cursor: onClick ? 'pointer' : 'default',
        background: hovered && onClick ? (theme?.backgrounds?.cardHover || '#f9fafb') : 'transparent',
        borderBottom: isLast ? 'none' : `1px solid ${theme?.borders?.primary || '#e5e7eb'}`,
        transition: 'background 0.15s ease',
      }}
    >
      {icon && (
        <div style={{
          width: '2rem',
          height: '2rem',
          borderRadius: '0.5rem',
          background: iconColor ? `${iconColor}15` : (theme?.primary?.blue?.[50] || '#eff6ff'),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          flexShrink: 0,
        }}>
          <FontAwesomeIcon
            icon={icon}
            style={{
              fontSize: '0.875rem',
              color: iconColor || theme?.primary?.blue?.[500] || '#3b82f6',
            }}
          />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '0.9375rem',
          fontWeight: '500',
          color: textColor || theme?.text?.primary || '#111827',
        }}>
          {title}
        </div>
        {subtitle && (
          <div style={{
            fontSize: '0.8125rem',
            color: theme?.text?.secondary || '#6b7280',
            marginTop: '0.125rem',
          }}>
            {subtitle}
          </div>
        )}
      </div>
      {onClick && (
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{
            fontSize: '0.75rem',
            color: theme?.text?.tertiary || '#9ca3af',
            marginLeft: '0.5rem',
          }}
        />
      )}
    </div>
  );
};
